/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Divider,
  Dialog,
  Breadcrumbs,
  DialogTitle,
  DialogContent,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import PushPinIcon from '@mui/icons-material/PushPin';
import dayjs from 'dayjs';
import MainLayout from '../../components/MainLayout';
import { ResponsiveHeading } from '../../styles/heading';
import { SmallHeading } from '../../styles/smallHeading';
import { apps } from '../Application/app';
import { ResponsiveSubHeading } from '../../styles/subHeading';
import {
  getGroupApps,
  resetGroupApps,
} from '../../Redux/Slices/Application/AppConfiguration/Group/group';
import { AppDispatch, RootState } from '../../Redux/store';
import { updateApplication } from '../../Redux/Slices/Application/appSlice';
import {
  setBreadcrumbOpen,
  setFilterRows,
  setApiType,
  updateStatusArray,
  updateFilterBox,
  // saveKeyValue,
  updateCasbApp,
  updateAppAccesses,
  updateStartTime,
  updateEndTime,
  updateSelectedDateButton,
  setSelectedApp,
} from '../../Redux/Slices/Auditing/auditing';
import { fetchRestrictionPerDay } from '../../Redux/Slices/Auditing/auditingHandler';
import { resetState } from '../UserInsights/userInsights';
import { renderNoDataMessage } from '../AuditingDashboard/AuditingDashboard';

interface App {
  title: string;
  smallLogo: string;
  imageSrc?: string;
  name?: string;
  isSingletonApplication?: boolean;
}

interface filteredRecords {
  [key: string]: any;
}
export const statusMapping: Record<string, string> = {
  IP_BASED_ACCESS_RESTRICTION: 'IP Restriction',
  LOCATION_BASED_ACCESS_RESTRICTION: 'Location Restriction',
  BLOCKED_APP: 'Blocked App',
  FILE_BASED_ACCESS_RESTRICTION: 'File Restriction',
  INVALID_SESSION_ACCESS_RESTRICTION: 'Invalid Session Restriction',
  FILE_FORMAT_BASED_ACCESS_RESTRICTION: 'File Format Restriction',
  OFFICE365_CUSTOM_COPY_FILE_RESTRICTION: 'Office365 Copy File Restriction',
  OFFICE365_CUSTOM_DELETE_FILE_RESTRICTION: 'Office365 Delete File Restriction',
  TIME_BASED_ACCESS_RESTRICTION: 'Time Restriction',
};

export const handleOpenModal = (
  appData: Record<string, any>,
  isBreadcrumbOpen: boolean,
  dispatch: AppDispatch,
  setSingletonApp: (app: Record<string, any> | null) => void,
  setOpenModal: (open: boolean) => void,
): void => {
  setSingletonApp(null);
  dispatch(setFilterRows([{ id: Date.now() }]));
  const now = dayjs();
  let selectedFromDate = dayjs();
  selectedFromDate = now.subtract(1, 'month');
  const formattedStartTime = selectedFromDate.format('YYYY-MM-DD HH:mm:ss');
  const formattedEndTime = now.format('YYYY-MM-DD HH:mm:ss');
  dispatch(updateSelectedDateButton(30));
  dispatch(updateStartTime(formattedStartTime));
  dispatch(updateEndTime(formattedEndTime));

  const appln = isBreadcrumbOpen ? `${appData.appKey}` : appData.title;
  if (isBreadcrumbOpen) {
    dispatch(updateAppAccesses([appln.toLowerCase()]));
  } else {
    dispatch(updateCasbApp([appln.toLowerCase()]));
  }
  dispatch(setApiType('count'));
  dispatch(fetchRestrictionPerDay()).then(() => {
    setSingletonApp(appData);
    setOpenModal(true);
  });
};

interface SingletonApplicationsProps {
  appName: string;
  displayedApps: any[];
  styles: any;
}

export function SingletonApplications({
  appName,
  displayedApps,
  styles,
}: SingletonApplicationsProps) {
  const dispatch = useDispatch<AppDispatch>();
  const singletonColors = ['#efe5fe', '#fef4eb', '#e9fff2', '#eeeeee'];
  const navigate = useNavigate();

  const {
    isBreadcrumbOpen,
    totalUsers,
    appAccessed,
    casbApp,
    pinnedAppln,
  } = useSelector((state: RootState) => state.auditingDashboard);
  const [appsWithPinnedStatus, setAppsWithPinnedStatus] = useState<any[]>();
  const [openModal, setOpenModal] = useState(false);
  const [singletonApp, setSingletonApp] = useState<Record<string, any> | null>(
    null,
  );

  const openModalHandler = (
    modalAppName: string,
    app: Record<string, string>,
    modalIsBreadcrumbOpen: boolean,
    modalDispatch: AppDispatch,
    modalSetSingletonApp: (appln: Record<string, any> | null) => void,
    modalSetOpenModal: (open: boolean) => void,
  ) => {
    if (
      modalAppName === 'ConfiguredApps' ||
      modalAppName === 'NonConfiguredApps'
    ) {
      navigate(app.path);
      return;
    }
    modalSetSingletonApp(app as Record<string, any>);
    modalSetOpenModal(true);
    handleOpenModal(
      app,
      modalIsBreadcrumbOpen,
      modalDispatch,
      modalSetSingletonApp,
      modalSetOpenModal,
    );
  };

  useEffect(() => {
    if (!pinnedAppln || !displayedApps) return;

    const updatedApps = displayedApps
      ?.map((app) => {
        const keysToSearch = [appName || 'Singleton'];
        const filteredData: filteredRecords = keysToSearch.reduce(
          (result, key) => {
            if (pinnedAppln[key]) {
              result[key] = pinnedAppln[key];
            }
            return result;
          },
          {} as filteredRecords,
        );

        const isPinned = Object.values(filteredData).some((appList) =>
          appList.includes(app?.appKey ? app?.appKey : app.title),
        );

        return {
          ...app,
          pinned: isPinned,
        };
      })
      .sort((a, b) => (b.pinned === a.pinned ? 0 : b.pinned ? 1 : -1));

    setAppsWithPinnedStatus(updatedApps);
  }, [pinnedAppln, displayedApps]);

  const handleCloseModal = () => {
    setSingletonApp(null);
    resetState(dispatch);
    dispatch(setApiType('fields'));
    setOpenModal(false);
  };

  const handleSpecificRestriction = (restriction: string) => {
    dispatch(updateStatusArray([restriction]));
    dispatch(setApiType('fields'));
    const filters = [
      {
        id: Date.now(),
        selectedField: isBreadcrumbOpen ? 'appAccessed' : 'casbApp',
        chipList: [isBreadcrumbOpen ? appAccessed : casbApp],
        fromDateData: '',
        toDateData: '',
      },
      {
        id: Date.now() + 1,
        selectedField: 'status',
        chipList: [statusMapping[restriction]],
        fromDateData: '',
        toDateData: '',
      },
    ];
    dispatch(setFilterRows(filters));
    dispatch(updateFilterBox(true));
    dispatch(fetchRestrictionPerDay());

    dispatch(resetGroupApps());
    dispatch(setBreadcrumbOpen(false));
    navigate('/insights');
  };

  const appLength = displayedApps.length > 0;

  return (
    <Box mt={5}>
      {!isBreadcrumbOpen && (
        <SmallHeading>{appLength && styles.headingName}</SmallHeading>
      )}
      {appLength && (
        <Divider
          sx={{
            my: 2,
            height: '0.063rem',
            backgroundColor: '#ececec',
          }}
        />
      )}
      <Box display="flex" flexWrap="wrap" gap={6} marginTop={5}>
        {appsWithPinnedStatus?.map((app, index) => (
          <Box
            key={
              app.appKey
                ? `${app.appKey}-${index + 1}`
                : `${app.title}-${index + 1}`
            }
            sx={{
              width: styles.width,
              height: styles.height,
              border: '0.063rem solid #d9d9d9',
              borderRadius: '1.875rem',
              cursor: 'pointer',
            }}
            onClick={(e: React.MouseEvent<HTMLElement>) => {
              e.stopPropagation();
              openModalHandler(
                appName,
                app,
                isBreadcrumbOpen,
                dispatch,
                setSingletonApp,
                setOpenModal,
              );
            }}
          >
            <Box
              sx={{
                margin: 1,
                height: '70%',
                borderRadius: '1.875rem',
                backgroundColor:
                  singletonColors[index % singletonColors.length],
                border: '0.063rem solid #d9d9d9',
                padding: 2,
              }}
            >
              <Box display="flex" justifyContent="space-between">
                <Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      gap: 2,
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={
                        isBreadcrumbOpen
                          ? `${process.env.REACT_APP_NODE_BACKEND_URL}/api${app.imageSrc}`
                          : app.smallLogo
                      }
                      sx={{
                        height: styles.imgHeight,
                        width: styles.imgWidth,
                      }}
                    />
                    <ResponsiveHeading
                      sx={{
                        fontSize: '1.25rem !important',
                      }}
                    >
                      {isBreadcrumbOpen ? `${app.name}` : app.title} {}
                    </ResponsiveHeading>
                  </Box>
                </Box>
                <Box>{/* Will be adding icon button here */}</Box>
              </Box>
            </Box>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingX: 1.5,
                paddingY: 1,
              }}
            >
              <ResponsiveSubHeading
                variant="body1"
                sx={{
                  fontSize: '0.875rem',
                  marginBottom: 1,
                }}
              >
                <b />{' '}
              </ResponsiveSubHeading>

              <ResponsiveSubHeading
                sx={{
                  fontSize: styles.fontSize,
                  color: 'blue',
                  border: '0.063rem solid blue',
                  paddingY: 0.7,
                  paddingX: 2,
                  borderRadius: 6,
                  ':hover': {
                    backgroundColor: 'blue',
                    color: 'white',
                    cursor: 'pointer',
                  },
                }}
                onClick={(e: React.MouseEvent<HTMLElement>) => {
                  e.stopPropagation();
                  openModalHandler(
                    appName,
                    app,
                    isBreadcrumbOpen,
                    dispatch,
                    setSingletonApp,
                    setOpenModal,
                  );
                }}
              >
                {styles.buttonName}
              </ResponsiveSubHeading>
            </Box>
          </Box>
        ))}
      </Box>
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          sx: {
            padding: '0.5rem',
            boxShadow: '0rem 0.5rem 1rem rgba(0,0,0,0.12)',
            minWidth: '43.75rem',
            minHeight: '18.75rem',
            borderRadius: '1.563rem',
            height: totalUsers.length > 0 ? '37.5rem' : '18.75rem',
          },
        }}
      >
        <DialogTitle>
          {singletonApp && (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              gap={2}
              paddingX={1}
            >
              <Box display="flex" alignItems="center" gap={3}>
                <Box>
                  <CardMedia
                    component="img"
                    image={
                      isBreadcrumbOpen
                        ? `${process.env.REACT_APP_NODE_BACKEND_URL}/api${singletonApp.imageSrc}`
                        : singletonApp.smallLogo
                    }
                    sx={{
                      height: '2.5rem',
                      width: '2.5rem',
                      borderRadius: '0.75rem',
                    }}
                  />
                </Box>
                <Box>
                  <ResponsiveHeading
                    sx={{
                      fontSize: styles.headingFontSize,
                    }}
                  >
                    {isBreadcrumbOpen ? singletonApp.name : singletonApp.title}
                  </ResponsiveHeading>
                </Box>
              </Box>

              <IconButton
                edge="end"
                onClick={handleCloseModal}
                sx={{
                  color: '#000',
                  padding: 1,
                  ':hover': {
                    color: 'blue',
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          )}
        </DialogTitle>

        <Box>
          {singletonApp && (
            <DialogContent>
              {totalUsers.length > 0 ? (
                <Box>
                  {totalUsers?.map((user, index) => (
                    <Box
                      key={`{${user.appAccessed}-${
                        user.count
                      }-${Math.random()}`}
                      display="flex"
                      alignItems="center"
                      mb={2}
                      sx={{
                        backgroundColor: '#fff8f1',
                        padding: 2,
                        borderRadius: '1.563rem',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleSpecificRestriction(user.status)}
                    >
                      <Box
                        sx={{
                          width: '4.375rem',
                          height: '4.375rem',
                          borderRadius: '50%',
                          backgroundColor: '#fce3b2',
                          color: 'black',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontWeight: 'bold',
                          fontSize: '1.25rem',
                          marginRight: 2,
                        }}
                      >
                        {user.count}
                      </Box>

                      <Box
                        sx={{
                          width: '0.25rem',
                          height: '3.75rem',
                          backgroundColor: '#fecb8d',
                          marginRight: 2,
                        }}
                      />
                      <ResponsiveHeading
                        sx={{
                          fontSize: '1.25rem !important',
                        }}
                      >
                        {statusMapping[user.status] || user.status}
                      </ResponsiveHeading>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Box mt={4}>{renderNoDataMessage()}</Box>
              )}
            </DialogContent>
          )}
        </Box>
      </Dialog>
    </Box>
  );
}

export const handleBreadcrumbClick = (dispatch: AppDispatch) => {
  dispatch(setSelectedApp(null));
  dispatch(resetGroupApps());
  dispatch(setBreadcrumbOpen(false));
};

export default function AppInsights() {
  const { apps: groupApps } = useSelector(
    (state: RootState) => state.groupSettings,
  );

  const { selectedApp } = useSelector(
    (state: RootState) => state.auditingDashboard,
  );

  const styles = {
    height: { xxl: '17.188rem', md: '14rem' },
    width: { xxl: '20%', md: '13.5rem' },
    fontSize: '0.875rem',
    buttonName: 'Details',
    headingName: 'Applications',
    imgHeight: { xxl: '3.125rem', md: '2.4rem' },
    imgWidth: { xxl: '3.125rem', md: '2.4rem' },
    headingFontSize: { xxl: '1.553rem', md: '1.2rem' },
  };

  const { pinnedAppln } = useSelector(
    (state: RootState) => state.auditingDashboard,
  );

  const [suiteApps, setSuiteApps] = useState<any[]>([]);
  const [appsWithPinnedStatus, setAppsWithPinnedStatus] = useState<any[]>();
  const dispatch = useDispatch<AppDispatch>();
  const singletonApps = Object.values(apps).filter(
    (app) => app.isSingletonApplication,
  );

  useEffect(() => {
    const filtered = Object.entries(apps)
      .filter(([, app]) => !app.isSingletonApplication)
      .map(([, app], index) => ({
        ...app,
        index,
      }));
    setSuiteApps(filtered);
  }, [apps]);

  useEffect(() => {
    if (!pinnedAppln || !suiteApps) return;

    const updatedApps = suiteApps
      ?.map((app) => {
        const keysToSearch = ['appSuite'];
        const filteredData: filteredRecords = keysToSearch.reduce(
          (result, key) => {
            if (pinnedAppln[key]) {
              result[key] = pinnedAppln[key];
            }
            return result;
          },
          {} as filteredRecords,
        );
        const isPinned = Object.values(filteredData).some((appList) =>
          appList.includes(app?.appKey ? app?.appKey : app.title),
        );

        return {
          ...app,
          pinned: isPinned,
        };
      })
      .sort((a, b) => (b.pinned === a.pinned ? 0 : b.pinned ? 1 : -1));

    setAppsWithPinnedStatus(updatedApps);
  }, [pinnedAppln, suiteApps]);

  const [displayedApps, setDisplayedApps] = useState<App[]>([]);
  const multiColors = ['#defbe9', '#fff1cc', '#dae9ff', '#f4edff'];

  useEffect(() => {
    setDisplayedApps(singletonApps);
    dispatch(setSelectedApp(null));
    dispatch(setBreadcrumbOpen(false));
  }, []);

  const handleArrowClick = (appName: string) => {
    const selectedAppln = Object.values(apps).find(
      (app) => app.title === appName,
    );
    resetState(dispatch);
    dispatch(setBreadcrumbOpen(true));
    dispatch(setSelectedApp(selectedAppln));
    dispatch(updateApplication(appName.toLowerCase()));
    dispatch(getGroupApps());
  };

  return (
    <MainLayout>
      <Box
        sx={{
          padding: 2,
          overflow: 'auto',
          maxHeight: '95vh',
        }}
      >
        <Box display="flex" flexDirection="column" mb={2} marginInline={5}>
          <Box p={1} width="100%">
            {!selectedApp && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <ResponsiveHeading>Application Insights</ResponsiveHeading>
              </Box>
            )}
            {selectedApp && (
              <Box mt={2}>
                <Breadcrumbs aria-label="breadcrumb">
                  <SmallHeading
                    underline="hover"
                    onClick={() => handleBreadcrumbClick(dispatch)}
                    sx={{
                      cursor: 'pointer',
                      textDecoration: 'underline',
                      '&:hover': {},
                    }}
                  >
                    Applications
                  </SmallHeading>
                  <SmallHeading sx={{ color: '#3d3d3d' }}>
                    {selectedApp.title}
                  </SmallHeading>
                </Breadcrumbs>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    mt: 4,
                  }}
                >
                  <CardMedia
                    component="img"
                    image={selectedApp.smallLogo}
                    sx={{
                      height: '3.75rem',
                      width: '3.75rem',
                    }}
                  />
                  <ResponsiveHeading>{selectedApp.title}</ResponsiveHeading>
                </Box>
              </Box>
            )}
            <Box>
              <Box marginTop={4}>
                {!selectedApp ? (
                  <Box>
                    <Box>
                      <Box marginTop={6}>
                        <SmallHeading>Application Suite</SmallHeading>
                        <Divider
                          sx={{
                            mt: 2,
                            marginBottom: 5,
                            height: '0.063rem',
                            backgroundColor: '#ececec',
                          }}
                        />
                        <Box display="flex" flexWrap="wrap" gap={3}>
                          {appsWithPinnedStatus?.map((app, index) => (
                            <Box
                              key={app.appKey || `${app.title}-${index}`}
                              sx={{ width: '17.188rem', height: '15rem' }}
                            >
                              <Box>
                                <Card
                                  elevation={3}
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    justifyContent: 'flex-start',
                                    padding: 1,
                                    backgroundColor:
                                      multiColors[index % multiColors.length],
                                    borderRadius: '2.188rem',
                                    height: '15rem',
                                    boxShadow: 'none',
                                    width: '100%',
                                    border: '0.063rem solid #d9d9d9',
                                    position: 'relative',
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'flex-start',
                                      marginTop: 2,
                                      marginLeft: 2,
                                    }}
                                  >
                                    <CardMedia
                                      component="img"
                                      image={app.smallLogo}
                                      sx={{
                                        height: '2.5rem',
                                        width: '2.5rem',
                                        marginBottom: 1,
                                      }}
                                    />
                                    <CardContent
                                      sx={{ padding: 0, marginTop: '1rem' }}
                                    >
                                      <ResponsiveHeading
                                        sx={{
                                          fontSize: '1.25rem !important',
                                        }}
                                      >
                                        {app.title}
                                      </ResponsiveHeading>
                                    </CardContent>
                                  </Box>
                                  {/* Here there will be pushpin icon functionality */}
                                  <IconButton
                                    sx={{
                                      position: 'absolute',
                                      bottom: '0.625rem',
                                      right: '0.938rem',
                                      backgroundColor: '#ffffff',
                                      borderRadius: '50%',
                                      padding: '1rem',
                                      fontSize: '1rem',
                                      ':hover': {
                                        backgroundColor: '#0052cc',
                                        color: 'white',
                                      },
                                    }}
                                    onClick={() => handleArrowClick(app.title)}
                                  >
                                    <ArrowForwardIcon />
                                  </IconButton>
                                </Card>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    </Box>
                    <Box>
                      <SingletonApplications
                        appName="Singleton"
                        displayedApps={displayedApps}
                        styles={styles}
                      />
                    </Box>
                  </Box>
                ) : (
                  <SingletonApplications
                    appName={selectedApp}
                    displayedApps={groupApps}
                    styles={styles}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </MainLayout>
  );
}
